import { useRef, useState, useEffect } from "react";
import styles from "./index.module.css";

const Drawermenu = ({ setShowMenu, showMenu, children }) => {
  const modalRef = useRef(null);
  const startXRef = useRef(null);
  const [dragDistance, setDragDistance] = useState(showMenu ? -500 : 0);
  const [isClosing, setIsClosing] = useState(false);
  const [isOpening, setIsOpening] = useState(true);
  const dragThreshold = -60;

  const handleOverlayClick = () => {
    if (isClosing) return;
    setIsClosing(true);
    setDragDistance(-500);
    setTimeout(() => {
      setShowMenu(false);
      setIsClosing(false);
      setDragDistance(0);
      startXRef.current = null;
    }, 200);
  };

  const handleTouchMove = (e) => {
    if (isClosing) return;
    if (e.target.closest(`.${styles.menuCategories}`)) return;

    const currentX = e.touches[0].clientX;

    if (startXRef.current === null) {
      startXRef.current = currentX;
      setDragDistance(0);
    } else {
      const deltaX = currentX - startXRef.current;
      if (deltaX < 0) {
        setDragDistance(deltaX);
        e.preventDefault();
      }
    }
  };

  const handleTouchEnd = () => {
    if (dragDistance < dragThreshold) {
      handleOverlayClick();
    } else {
      setDragDistance(0);
    }
    startXRef.current = null;
  };

  useEffect(() => {
    const modal = modalRef.current;
    if (!modal) return;

    const preventScroll = (e) => {
      if (e.target === modal) e.preventDefault();
    };

    modal.addEventListener("touchmove", preventScroll, { passive: false });
    return () => modal.removeEventListener("touchmove", preventScroll);
  }, []);

  useEffect(() => {
    if (showMenu) {
      setIsOpening(true);
      setDragDistance(0);
      setTimeout(() => setIsOpening(false), 200);
    } else {
      setDragDistance(-500);
    }
  }, [showMenu]);

  useEffect(() => {
    if (!showMenu) return;

    const scrollY = window.scrollY;
    const body = document.body;

    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    body.style.overflowY = "scroll";

    return () => {
      const storedScrollY = body.style.top;
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.overflowY = "";

      window.scrollTo(0, parseInt(storedScrollY || "0") * -1);
    };
  }, [showMenu]);

  return (
    <div className={styles.drawerMenuOverlay} onClick={handleOverlayClick}>
      <div
        className={styles.drawerMenuModal}
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        aria-label="Storefront menu"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        style={{
          transform: `translateX(${dragDistance}px)`,
          transition:
            dragDistance === 0 || isClosing || isOpening
              ? "transform 0.2s ease-out"
              : "none",
        }}
      >
        {typeof children === "function"
          ? children({ closeMenu: handleOverlayClick })
          : children}
      </div>
    </div>
  );
};

export default Drawermenu;
